import template from './component.tpl.html';
import './controller';

/**
 * @ngdoc component
 * @name components.component:al-bo-selector
 * @restrict EA
 * @element
 *
 * @description
 *
 * @example
 <example module="components">
 <file name="index.html">
 <al-bo-selector bo-model="" bookable-objects="[]" on-update="updated(newSelection)"></al-bo-selector>
 </file>
 </example>
 *
 */
angular
    .module('festzelt-os.components')
    .component('alBoSelector', {
        bindings: {
            boModel: '<',
            bookableObjects: '<',
            onUpdate: '&'
        },
        controller: 'ComponentsAlBoSelectorController',
        controllerAs: 'vm',
        templateUrl: template
    });



// WEBPACK FOOTER //
// ./src/app/modules/bo/components/al-bo-selector/component.js